const VITALS = new Set(['cls', 'inp', 'lcp', 'fcp', 'ttfb']);
const RATINGS = new Set(['good', 'needs-improvement', 'poor']);
const NAVIGATIONS = new Set([
  'navigate', 'reload', 'back-forward', 'back-forward-cache', 'prerender', 'restore',
]);
const METADATA_FIELDS = new Set([
  'collector', 'collectorVersion', 'id', 'snapshotRevision', 'rating', 'delta', 'navigationType',
]);

// Deliberately recognize only this collector's small, scalar-only contract.
// Legacy/custom metrics remain append-only and keep their existing semantics.
export const getWebVitalSnapshotKey = (sample) => {
  const metadata = sample?.metadata;
  if (!VITALS.has(sample?.metric) || !metadata || typeof metadata !== 'object') return null;
  if (metadata.collector !== 'web-vitals' || metadata.collectorVersion !== '6.2.3'
    || typeof metadata.id !== 'string' || !/^[a-zA-Z0-9_-]{1,128}$/.test(metadata.id)
    || !Number.isSafeInteger(metadata.snapshotRevision) || metadata.snapshotRevision < 1
    || !RATINGS.has(metadata.rating) || !NAVIGATIONS.has(metadata.navigationType)
    || !Number.isFinite(metadata.delta)
    || Object.keys(metadata).some((key) => !METADATA_FIELDS.has(key))) return null;
  return `${sample.metric}:${metadata.id}`;
};

// An upload acknowledges the exact captured snapshot, never a newer revision
// that arrived with the same stable record ID while the request was in flight.
export const sameMetricSnapshot = (left, right) => (
  Boolean(left && right && typeof left.id === 'string' && left.id === right.id)
  && left.metadata?.snapshotRevision === right.metadata?.snapshotRevision
);
